export default __webpack_public_path__ + "static/media/parking-sign.18da54ec.svg";